// search界面工具栏按钮模板
export const mainToolBarTemplate = {
  // 新增
  add: {
    Visible: true,
    Enable: false,
  },
  // 查看
  see: {
    Visible: true,
    Enable: true,
  },
  // 编辑
  update: {
    Visible: true,
    Enable: false,
  },
  // 查询
  search: {
    Visible: true,
    Enable: true,
  },
  // 导出
  exp: {
    Visible: true,
    Enable: true,
  },
  // 打印
  print: {
    Visible: false,
    Enable: true,
  },
  // 收藏
  Favor: {
    Visible: true,
    Enable: true,
  },
  // 扩展功能
  more: {
    Visible: true,
    Enable: true,
  },
  // 高级查找
  mysearch: {
    Visible: true,
    Enable: true,
  },
}
// single界面工具栏按钮模板
export const singleToolBarTemplate = {
  // 保存按钮
  save: {
    Visible: true,
    Enable: false,
  },
  // 编辑按钮
  edit: {
    Visible: true,
    Enable: true,
  },
  // 删除按钮
  del: {
    Visible: true,
    Enable: false,
  },
  // 锁定按钮
  lock: {
    Visible: true,
    Enable: false,
  },
  // 解锁按钮
  unlock: {
    Visible: true,
    Enable: false,
  },
  // 传递、传递反馈按钮
  notify: {
    Visible: true,
    Enable: true,
  },
  // 导出
  exp: {
    Visible: false,
    Enable: true,
  },
  // 打印按钮
  print: {
    Visible: false,
    Enable: true,
  },
  // 重置按钮
  reset: {
    Visible: false,
    Enable: true,
  },
  // 扩展功能按钮
  more: {
    Visible: true,
    Enable: true,
  },
  // 附件按钮
  attachment: {
    Visible: true,
    Enable: true,
  },
  // 审批按钮
  approve: {
    Visible: true,
    Enable: true,
  },
  // 日志按钮
  log: {
    Visible: true,
    Enable: true,
  },
  // 隐藏form
  hide: {
    Visible: false,
    Enable: true,
  },
  // 返回按钮
  back: {
    Visible: true,
    Enable: true,
  },
}
// 权限模板
export const authorityTemplate = {
  // 是否可查看
  see: true,
  // 查看本人、本部门、本公司、所有人
  seeType: 0,
  // 生效条件
  alEffectCondition: '保存',
  // 是否可编辑
  edit: false,
  // 特殊权限
  special: [{}],
  // 授权人员ID
  empower: [],
  // 是否有查看金额权限
  showMoney: false,
  // 是否自动编码
  autoCode: true,
}
// 下拉框配置
export const comboboxconfig = {
  // 年份
  year: [
    2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028,
    2029, 2030,
  ],
  // 月份
  month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  // 是否
  yesorno: ['是', '否'],
  // 有效、无效
  valid: ['有效', '无效'],
  // 性别
  sex: ['男', '女'],
  // 政治面貌
  politics: ['群众', '党员', '团员'],
  // 婚姻情况
  marryStatus: ['已婚', '未婚', '离异'],
  // 学历
  education: [
    '小学',
    '初中',
    '高中',
    '技校',
    '中技',
    '中专',
    '大专',
    '本科',
    '研究生',
    '博士',
  ],
  // 在职状态
  employeeStatus: ['在职', '离职'],
}
// 各高度配置
export const heightconfig = {
  // HomeHeader 高度
  headerHeight: 40,
  // Home tab高度
  homeTabHeight: 35,
  // MainForm 工具栏高度
  mainToolBarHeight: 34,
  // SingleForm 工具栏高度
  singleToolBarHeight: 34,
  // SingleFooter高度
  singleFooterHeight: 55,
  // el-row高度
  elrowHeight: 25,
  // el-tabs高度
  eltabHeight: 30,
  // 主界面明细padding-top
  mainDetailPadHeight: 10,
  // el-divider高度
  eldividerHeight: 21,
}
// 公用字符串
export const messageConfig = {
  // 修改保存
  modifyClose: '存在修改，是否停留在该页面?',
  autoCode: '自动编码',
  inputPlaceholder: '输入',
  relationPlaceholder: '关联获取',
  defaultPlaceholder: '默认值',
  selectPlaceholder: '选择获取',
  calculatePlaceholder: '自动计算',
  emptyCurrent: '请选择要操作的数据!',
  emptyDataForSave: '不存在可保存数据!',
  blankDetail: '明细不能为空',
  save: {
    success: '保存成功',
  },
  del: {
    success: '删除成功',
    confirmTableRow: '确定删除本行数据？',
    confirm: '确定删除本单据？',
  },
  lock: {
    success: '锁定成功',
  },
  unlock: {
    success: '解锁成功',
  },
  push: {
    success: '下推成功',
  },
}
// 公用图标
export const iconConfig = {
  // 作废
  invalid: 'el-icon-circle-close',
  // 恢复
  recover: 'el-icon-refresh-left',
  // 复制
  copy: 'el-icon-document-copy',
  // 人员
  human: 'el-icon-user-solid',
  // 选择数据源
  source: 'el-icon-document',
  // 上传
  upload: 'el-icon-upload',
  // 下推
  push: 'el-icon-download',
}
// VXETable配置
export const tableconfig = {
  // table header高度
  headerHeight: 25,
  // table row高度
  rowHeight: 27,
  // 每页条数
  pageSizes: [50, 100, 200, 1000, 2000, 50000],
  // 默认每页条数
  defaultPageSize: 50,
  // 斑马纹颜色
  stripeColor: 'lightgray',
}
// 数值验证
export const validNumerical = {
  // 不限制
  none: 0,
  // 非负数
  nonNegative: 1,
  // 大于0
  greaterThanZero: 2,
  // 不能为0(仅整数有效)
  noZero: 3,
  // 为负数
  isNegative: 4,
}

// 国家省份城市
export const placeInfo = [
  {
    label: '中国',
    value: '中国',
    children: [
      {
        label: '北京',
        value: '北京',
        children: [
          {
            label: '东城区',
            value: '东城区',
          },
          {
            label: '西城区',
            value: '西城区',
          },
          {
            label: '崇文区',
            value: '崇文区',
          },
          {
            label: '宣武区',
            value: '宣武区',
          },
          {
            label: '朝阳区',
            value: '朝阳区',
          },
          {
            label: '丰台区',
            value: '丰台区',
          },
          {
            label: '石景山区',
            value: '石景山区',
          },
          {
            label: '海淀区',
            value: '海淀区',
          },
          {
            label: '门头沟区',
            value: '门头沟区',
          },
          {
            label: '房山区',
            value: '房山区',
          },
          {
            label: '通州区',
            value: '通州区',
          },
          {
            label: '顺义区',
            value: '顺义区',
          },
          {
            label: '昌平区',
            value: '昌平区',
          },
          {
            label: '大兴区',
            value: '大兴区',
          },
          {
            label: '平谷区',
            value: '平谷区',
          },
          {
            label: '怀柔区',
            value: '怀柔区',
          },
          {
            label: '密云县',
            value: '密云县',
          },
          {
            label: '延庆县',
            value: '延庆县',
          },
        ],
      },
      {
        label: '天津',
        value: '天津',
        children: [
          {
            label: '和平区',
            value: '和平区',
          },
          {
            label: '河东区',
            value: '河东区',
          },
          {
            label: '河西区',
            value: '河西区',
          },
          {
            label: '南开区',
            value: '南开区',
          },
          {
            label: '河北区',
            value: '河北区',
          },
          {
            label: '红桥区',
            value: '红桥区',
          },
          {
            label: '塘沽区',
            value: '塘沽区',
          },
          {
            label: '汉沽区',
            value: '汉沽区',
          },
          {
            label: '大港区',
            value: '大港区',
          },
          {
            label: '东丽区',
            value: '东丽区',
          },
          {
            label: '西青区',
            value: '西青区',
          },
          {
            label: '津南区',
            value: '津南区',
          },
          {
            label: '北辰区',
            value: '北辰区',
          },
          {
            label: '武清区',
            value: '武清区',
          },
          {
            label: '宝坻区',
            value: '宝坻区',
          },
          {
            label: '宁河县',
            value: '宁河县',
          },
          {
            label: '静海县',
            value: '静海县',
          },
          {
            label: '蓟县',
            value: '蓟县',
          },
        ],
      },
      {
        label: '河北',
        value: '河北',
        children: [
          {
            label: '石家庄',
            value: '石家庄',
          },
          {
            label: '唐山',
            value: '唐山',
          },
          {
            label: '秦皇岛',
            value: '秦皇岛',
          },
          {
            label: '邯郸',
            value: '邯郸',
          },
          {
            label: '邢台',
            value: '邢台',
          },
          {
            label: '保定',
            value: '保定',
          },
          {
            label: '张家口',
            value: '张家口',
          },
          {
            label: '承德',
            value: '承德',
          },
          {
            label: '沧州',
            value: '沧州',
          },
          {
            label: '廊坊',
            value: '廊坊',
          },
          {
            label: '衡水',
            value: '衡水',
          },
        ],
      },
      {
        label: '山西',
        value: '山西',
        children: [
          {
            label: '太原',
            value: '太原',
          },
          {
            label: '大同',
            value: '大同',
          },
          {
            label: '阳泉',
            value: '阳泉',
          },
          {
            label: '长治',
            value: '长治',
          },
          {
            label: '晋城',
            value: '晋城',
          },
          {
            label: '朔州',
            value: '朔州',
          },
          {
            label: '忻州',
            value: '忻州',
          },
          {
            label: '吕梁',
            value: '吕梁',
          },
          {
            label: '晋中',
            value: '晋中',
          },
          {
            label: '临汾',
            value: '临汾',
          },
          {
            label: '运城',
            value: '运城',
          },
        ],
      },
      {
        label: '内蒙古',
        value: '内蒙古',
        children: [
          {
            label: '呼和浩特',
            value: '呼和浩特',
          },
          {
            label: '包头',
            value: '包头',
          },
          {
            label: '乌海',
            value: '乌海',
          },
          {
            label: '赤峰',
            value: '赤峰',
          },
          {
            label: '呼伦贝尔',
            value: '呼伦贝尔',
          },
          {
            label: '兴安盟',
            value: '兴安盟',
          },
          {
            label: '通辽',
            value: '通辽',
          },
          {
            label: '锡林郭勒盟',
            value: '锡林郭勒盟',
          },
          {
            label: '乌兰察布盟',
            value: '乌兰察布盟',
          },
          {
            label: '伊克昭盟',
            value: '伊克昭盟',
          },
          {
            label: '巴彦淖尔盟',
            value: '巴彦淖尔盟',
          },
          {
            label: '阿拉善盟',
            value: '阿拉善盟',
          },
        ],
      },
      {
        label: '辽宁',
        value: '辽宁',
        children: [
          {
            label: '沈阳',
            value: '沈阳',
          },
          {
            label: '大连',
            value: '大连',
          },
          {
            label: '鞍山',
            value: '鞍山',
          },
          {
            label: '抚顺',
            value: '抚顺',
          },
          {
            label: '本溪',
            value: '本溪',
          },
          {
            label: '丹东',
            value: '丹东',
          },
          {
            label: '锦州',
            value: '锦州',
          },
          {
            label: '营口',
            value: '营口',
          },
          {
            label: '阜新',
            value: '阜新',
          },
          {
            label: '辽阳',
            value: '辽阳',
          },
          {
            label: '盘锦',
            value: '盘锦',
          },
          {
            label: '铁岭',
            value: '铁岭',
          },
          {
            label: '朝阳',
            value: '朝阳',
          },
          {
            label: '葫芦岛',
            value: '葫芦岛',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '吉林',
        value: '吉林',
        children: [
          {
            label: '长春',
            value: '长春',
          },
          {
            label: '吉林',
            value: '吉林',
          },
          {
            label: '四平',
            value: '四平',
          },
          {
            label: '辽源',
            value: '辽源',
          },
          {
            label: '通化',
            value: '通化',
          },
          {
            label: '白山',
            value: '白山',
          },
          {
            label: '松原',
            value: '松原',
          },
          {
            label: '白城',
            value: '白城',
          },
          {
            label: '延边朝鲜族自治州',
            value: '延边朝鲜族自治州',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '黑龙江',
        value: '黑龙江',
        children: [
          {
            label: '哈尔滨',
            value: '哈尔滨',
          },
          {
            label: '齐齐哈尔',
            value: '齐齐哈尔',
          },
          {
            label: '鹤岗',
            value: '鹤岗',
          },
          {
            label: '双鸭山',
            value: '双鸭山',
          },
          {
            label: '鸡西',
            value: '鸡西',
          },
          {
            label: '大庆',
            value: '大庆',
          },
          {
            label: '伊春',
            value: '伊春',
          },
          {
            label: '牡丹江',
            value: '牡丹江',
          },
          {
            label: '佳木斯',
            value: '佳木斯',
          },
          {
            label: '七台河',
            value: '七台河',
          },
          {
            label: '黑河',
            value: '黑河',
          },
          {
            label: '绥化',
            value: '绥化',
          },
          {
            label: '大兴安岭地区',
            value: '大兴安岭地区',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '上海',
        value: '上海',
        children: [
          {
            label: '黄浦区',
            value: '黄浦区',
          },
          {
            label: '卢湾区',
            value: '卢湾区',
          },
          {
            label: '徐汇区',
            value: '徐汇区',
          },
          {
            label: '长宁区',
            value: '长宁区',
          },
          {
            label: '静安区',
            value: '静安区',
          },
          {
            label: '普陀区',
            value: '普陀区',
          },
          {
            label: '闸北区',
            value: '闸北区',
          },
          {
            label: '虹口区',
            value: '虹口区',
          },
          {
            label: '杨浦区',
            value: '杨浦区',
          },
          {
            label: '宝山区',
            value: '宝山区',
          },
          {
            label: '闵行区',
            value: '闵行区',
          },
          {
            label: '嘉定区',
            value: '嘉定区',
          },
          {
            label: '松江区',
            value: '松江区',
          },
          {
            label: '金山区',
            value: '金山区',
          },
          {
            label: '青浦区',
            value: '青浦区',
          },
          {
            label: '南汇区',
            value: '南汇区',
          },
          {
            label: '奉贤区',
            value: '奉贤区',
          },
          {
            label: '浦东新区',
            value: '浦东新区',
          },
          {
            label: '崇明县',
            value: '崇明县',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '江苏',
        value: '江苏',
        children: [
          {
            label: '南京',
            value: '南京',
          },
          {
            label: '苏州',
            value: '苏州',
          },
          {
            label: '无锡',
            value: '无锡',
          },
          {
            label: '常州',
            value: '常州',
          },
          {
            label: '镇江',
            value: '镇江',
          },
          {
            label: '南通',
            value: '南通',
          },
          {
            label: '泰州',
            value: '泰州',
          },
          {
            label: '扬州',
            value: '扬州',
          },
          {
            label: '盐城',
            value: '盐城',
          },
          {
            label: '连云港',
            value: '连云港',
          },
          {
            label: '徐州',
            value: '徐州',
          },
          {
            label: '淮安',
            value: '淮安',
          },
          {
            label: '宿迁',
            value: '宿迁',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '浙江',
        value: '浙江',
        children: [
          {
            label: '杭州',
            value: '杭州',
          },
          {
            label: '宁波',
            value: '宁波',
          },
          {
            label: '温州',
            value: '温州',
          },
          {
            label: '嘉兴',
            value: '嘉兴',
          },
          {
            label: '湖州',
            value: '湖州',
          },
          {
            label: '绍兴',
            value: '绍兴',
          },
          {
            label: '金华',
            value: '金华',
          },
          {
            label: '衢州',
            value: '衢州',
          },
          {
            label: '舟山',
            value: '舟山',
          },
          {
            label: '台州',
            value: '台州',
          },
          {
            label: '丽水',
            value: '丽水',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '安徽',
        value: '安徽',
        children: [
          {
            label: '合肥',
            value: '合肥',
          },
          {
            label: '芜湖',
            value: '芜湖',
          },
          {
            label: '蚌埠',
            value: '蚌埠',
          },
          {
            label: '淮南',
            value: '淮南',
          },
          {
            label: '马鞍山',
            value: '马鞍山',
          },
          {
            label: '淮北',
            value: '淮北',
          },
          {
            label: '铜陵',
            value: '铜陵',
          },
          {
            label: '安庆',
            value: '安庆',
          },
          {
            label: '黄山',
            value: '黄山',
          },
          {
            label: '滁州',
            value: '滁州',
          },
          {
            label: '阜阳',
            value: '阜阳',
          },
          {
            label: '宿州',
            value: '宿州',
          },
          {
            label: '巢湖',
            value: '巢湖',
          },
          {
            label: '六安',
            value: '六安',
          },
          {
            label: '亳州',
            value: '亳州',
          },
          {
            label: '池州',
            value: '池州',
          },
          {
            label: '宣城',
            value: '宣城',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '福建',
        value: '福建',
        children: [
          {
            label: '福州',
            value: '福州',
          },
          {
            label: '厦门',
            value: '厦门',
          },
          {
            label: '莆田',
            value: '莆田',
          },
          {
            label: '三明',
            value: '三明',
          },
          {
            label: '泉州',
            value: '泉州',
          },
          {
            label: '漳州',
            value: '漳州',
          },
          {
            label: '南平',
            value: '南平',
          },
          {
            label: '龙岩',
            value: '龙岩',
          },
          {
            label: '宁德',
            value: '宁德',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '江西',
        value: '江西',
        children: [
          {
            label: '南昌',
            value: '南昌',
          },
          {
            label: '景德镇',
            value: '景德镇',
          },
          {
            label: '萍乡',
            value: '萍乡',
          },
          {
            label: '九江',
            value: '九江',
          },
          {
            label: '新余',
            value: '新余',
          },
          {
            label: '鹰潭',
            value: '鹰潭',
          },
          {
            label: '赣州',
            value: '赣州',
          },
          {
            label: '吉安',
            value: '吉安',
          },
          {
            label: '宜春',
            value: '宜春',
          },
          {
            label: '抚州',
            value: '抚州',
          },
          {
            label: '上饶',
            value: '上饶',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '山东',
        value: '山东',
        children: [
          {
            label: '济南',
            value: '济南',
          },
          {
            label: '青岛',
            value: '青岛',
          },
          {
            label: '淄博',
            value: '淄博',
          },
          {
            label: '枣庄',
            value: '枣庄',
          },
          {
            label: '东营',
            value: '东营',
          },
          {
            label: '烟台',
            value: '烟台',
          },
          {
            label: '潍坊',
            value: '潍坊',
          },
          {
            label: '济宁',
            value: '济宁',
          },
          {
            label: '泰安',
            value: '泰安',
          },
          {
            label: '威海',
            value: '威海',
          },
          {
            label: '日照',
            value: '日照',
          },
          {
            label: '莱芜',
            value: '莱芜',
          },
          {
            label: '临沂',
            value: '临沂',
          },
          {
            label: '德州',
            value: '德州',
          },
          {
            label: '聊城',
            value: '聊城',
          },
          {
            label: '滨州',
            value: '滨州',
          },
          {
            label: '菏泽',
            value: '菏泽',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '河南',
        value: '河南',
        children: [
          {
            label: '郑州',
            value: '郑州',
          },
          {
            label: '开封',
            value: '开封',
          },
          {
            label: '洛阳',
            value: '洛阳',
          },
          {
            label: '平顶山',
            value: '平顶山',
          },
          {
            label: '安阳',
            value: '安阳',
          },
          {
            label: '鹤壁',
            value: '鹤壁',
          },
          {
            label: '新乡',
            value: '新乡',
          },
          {
            label: '焦作',
            value: '焦作',
          },
          {
            label: '濮阳',
            value: '濮阳',
          },
          {
            label: '许昌',
            value: '许昌',
          },
          {
            label: '漯河',
            value: '漯河',
          },
          {
            label: '三门峡',
            value: '三门峡',
          },
          {
            label: '南阳',
            value: '南阳',
          },
          {
            label: '商丘',
            value: '商丘',
          },
          {
            label: '信阳',
            value: '信阳',
          },
          {
            label: '周口',
            value: '周口',
          },
          {
            label: '驻马店',
            value: '驻马店',
          },
          {
            label: '焦作',
            value: '焦作',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '湖北',
        value: '湖北',
        children: [
          {
            label: '武汉',
            value: '武汉',
          },
          {
            label: '黄石',
            value: '黄石',
          },
          {
            label: '十堰',
            value: '十堰',
          },
          {
            label: '荆州',
            value: '荆州',
          },
          {
            label: '宜昌',
            value: '宜昌',
          },
          {
            label: '襄樊',
            value: '襄樊',
          },
          {
            label: '鄂州',
            value: '鄂州',
          },
          {
            label: '荆门',
            value: '荆门',
          },
          {
            label: '孝感',
            value: '孝感',
          },
          {
            label: '黄冈',
            value: '黄冈',
          },
          {
            label: '咸宁',
            value: '咸宁',
          },
          {
            label: '随州',
            value: '随州',
          },
          {
            label: '恩施土家族苗族自治州',
            value: '恩施土家族苗族自治州',
          },
          {
            label: '仙桃',
            value: '仙桃',
          },
          {
            label: '天门',
            value: '天门',
          },
          {
            label: '潜江',
            value: '潜江',
          },
          {
            label: '神农架林区',
            value: '神农架林区',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '湖南',
        value: '湖南',
        children: [
          {
            label: '长沙',
            value: '长沙',
          },
          {
            label: '株洲',
            value: '株洲',
          },
          {
            label: '湘潭',
            value: '湘潭',
          },
          {
            label: '衡阳',
            value: '衡阳',
          },
          {
            label: '邵阳',
            value: '邵阳',
          },
          {
            label: '岳阳',
            value: '岳阳',
          },
          {
            label: '常德',
            value: '常德',
          },
          {
            label: '张家界',
            value: '张家界',
          },
          {
            label: '益阳',
            value: '益阳',
          },
          {
            label: '郴州',
            value: '郴州',
          },
          {
            label: '永州',
            value: '永州',
          },
          {
            label: '怀化',
            value: '怀化',
          },
          {
            label: '娄底',
            value: '娄底',
          },
          {
            label: '湘西土家族苗族自治州',
            value: '湘西土家族苗族自治州',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '广东',
        value: '广东',
        children: [
          {
            label: '广州',
            value: '广州',
          },
          {
            label: '深圳',
            value: '深圳',
          },
          {
            label: '东莞',
            value: '东莞',
          },
          {
            label: '中山',
            value: '中山',
            children: [
              {
                value: '中山',
              },
            ],
          },
          {
            label: '潮州',
            value: '潮州',
          },
          {
            label: '揭阳',
            value: '揭阳',
          },
          {
            label: '云浮',
            value: '云浮',
          },
          {
            label: '珠海',
            value: '珠海',
          },
          {
            label: '汕头',
            value: '汕头',
          },
          {
            label: '韶关',
            value: '韶关',
          },
          {
            label: '佛山',
            value: '佛山',
          },
          {
            label: '江门',
            value: '江门',
          },
          {
            label: '湛江',
            value: '湛江',
          },
          {
            label: '茂名',
            value: '茂名',
          },
          {
            label: '肇庆',
            value: '肇庆',
          },
          {
            label: '惠州',
            value: '惠州',
          },
          {
            label: '梅州',
            value: '梅州',
          },
          {
            label: '汕尾',
            value: '汕尾',
          },
          {
            label: '河源',
            value: '河源',
          },
          {
            label: '阳江',
            value: '阳江',
          },
          {
            label: '清远',
            value: '清远',
          },
        ],
      },
      {
        label: '广西',
        value: '广西',
        children: [
          {
            label: '南宁',
            value: '南宁',
          },
          {
            label: '柳州',
            value: '柳州',
          },
          {
            label: '桂林',
            value: '桂林',
          },
          {
            label: '梧州',
            value: '梧州',
          },
          {
            label: '北海',
            value: '北海',
          },
          {
            label: '防城港',
            value: '防城港',
          },
          {
            label: '钦州',
            value: '钦州',
          },
          {
            label: '贵港',
            value: '贵港',
          },
          {
            label: '玉林',
            value: '玉林',
          },
          {
            label: '百色',
            value: '百色',
          },
          {
            label: '贺州',
            value: '贺州',
          },
          {
            label: '河池',
            value: '河池',
          },
          {
            label: '来宾',
            value: '来宾',
          },
          {
            label: '崇左',
            value: '崇左',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '海南',
        value: '海南',
        children: [
          {
            label: '海口',
            value: '海口',
          },
          {
            label: '三亚',
            value: '三亚',
          },
          {
            label: '五指山',
            value: '五指山',
          },
          {
            label: '琼海',
            value: '琼海',
          },
          {
            label: '儋州',
            value: '儋州',
          },
          {
            label: '文昌',
            value: '文昌',
          },
          {
            label: '万宁',
            value: '万宁',
          },
          {
            label: '东方',
            value: '东方',
          },
          {
            label: '澄迈县',
            value: '澄迈县',
          },
          {
            label: '定安县',
            value: '定安县',
          },
          {
            label: '屯昌县',
            value: '屯昌县',
          },
          {
            label: '临高县',
            value: '临高县',
          },
          {
            label: '白沙黎族自治县',
            value: '白沙黎族自治县',
          },
          {
            label: '昌江黎族自治县',
            value: '昌江黎族自治县',
          },
          {
            label: '乐东黎族自治县',
            value: '乐东黎族自治县',
          },
          {
            label: '陵水黎族自治县',
            value: '陵水黎族自治县',
          },
          {
            label: '保亭黎族苗族自治县',
            value: '保亭黎族苗族自治县',
          },
          {
            label: '琼中黎族苗族自治县',
            value: '琼中黎族苗族自治县',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '重庆',
        value: '重庆',
        children: [
          {
            label: '渝中区',
            value: '渝中区',
          },
          {
            label: '大渡口区',
            value: '大渡口区',
          },
          {
            label: '江北区',
            value: '江北区',
          },
          {
            label: '南岸区',
            value: '南岸区',
          },
          {
            label: '北碚区',
            value: '北碚区',
          },
          {
            label: '渝北区',
            value: '渝北区',
          },
          {
            label: '巴南区',
            value: '巴南区',
          },
          {
            label: '长寿区',
            value: '长寿区',
          },
          {
            label: '双桥区',
            value: '双桥区',
          },
          {
            label: '沙坪坝区',
            value: '沙坪坝区',
          },
          {
            label: '万盛区',
            value: '万盛区',
          },
          {
            label: '万州区',
            value: '万州区',
          },
          {
            label: '涪陵区',
            value: '涪陵区',
          },
          {
            label: '黔江区',
            value: '黔江区',
          },
          {
            label: '永川区',
            value: '永川区',
          },
          {
            label: '合川区',
            value: '合川区',
          },
          {
            label: '江津区',
            value: '江津区',
          },
          {
            label: '九龙坡区',
            value: '九龙坡区',
          },
          {
            label: '南川区',
            value: '南川区',
          },
          {
            label: '綦江县',
            value: '綦江县',
          },
          {
            label: '潼南县',
            value: '潼南县',
          },
          {
            label: '荣昌县',
            value: '荣昌县',
          },
          {
            label: '璧山县',
            value: '璧山县',
          },
          {
            label: '大足县',
            value: '大足县',
          },
          {
            label: '铜梁县',
            value: '铜梁县',
          },
          {
            label: '梁平县',
            value: '梁平县',
          },
          {
            label: '开县',
            value: '开县',
          },
          {
            label: '忠县',
            value: '忠县',
          },
          {
            label: '城口县',
            value: '城口县',
          },
          {
            label: '垫江县',
            value: '垫江县',
          },
          {
            label: '武隆县',
            value: '武隆县',
          },
          {
            label: '丰都县',
            value: '丰都县',
          },
          {
            label: '奉节县',
            value: '奉节县',
          },
          {
            label: '云阳县',
            value: '云阳县',
          },
          {
            label: '巫溪县',
            value: '巫溪县',
          },
          {
            label: '巫山县',
            value: '巫山县',
          },
          {
            label: '石柱土家族自治县',
            value: '石柱土家族自治县',
          },
          {
            label: '秀山土家族苗族自治县',
            value: '秀山土家族苗族自治县',
          },
          {
            label: '酉阳土家族苗族自治县',
            value: '酉阳土家族苗族自治县',
          },
          {
            label: '彭水苗族土家族自治县',
            value: '彭水苗族土家族自治县',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '四川',
        value: '四川',
        children: [
          {
            label: '成都',
            value: '成都',
          },
          {
            label: '自贡',
            value: '自贡',
          },
          {
            label: '攀枝花',
            value: '攀枝花',
          },
          {
            label: '泸州',
            value: '泸州',
          },
          {
            label: '德阳',
            value: '德阳',
          },
          {
            label: '绵阳',
            value: '绵阳',
          },
          {
            label: '广元',
            value: '广元',
          },
          {
            label: '遂宁',
            value: '遂宁',
          },
          {
            label: '内江',
            value: '内江',
          },
          {
            label: '乐山',
            value: '乐山',
          },
          {
            label: '南充',
            value: '南充',
          },
          {
            label: '眉山',
            value: '眉山',
          },
          {
            label: '宜宾',
            value: '宜宾',
          },
          {
            label: '广安',
            value: '广安',
          },
          {
            label: '达州',
            value: '达州',
          },
          {
            label: '雅安',
            value: '雅安',
          },
          {
            label: '巴中',
            value: '巴中',
          },
          {
            label: '资阳',
            value: '资阳',
          },
          {
            label: '阿坝藏族羌族自治州',
            value: '阿坝藏族羌族自治州',
          },
          {
            label: '甘孜藏族自治州',
            value: '甘孜藏族自治州',
          },
          {
            label: '凉山彝族自治州',
            value: '凉山彝族自治州',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '贵州',
        value: '贵州',
        children: [
          {
            label: '贵阳',
            value: '贵阳',
          },
          {
            label: '六盘水',
            value: '六盘水',
          },
          {
            label: '遵义',
            value: '遵义',
          },
          {
            label: '安顺',
            value: '安顺',
          },
          {
            label: '铜仁地区',
            value: '铜仁地区',
          },
          {
            label: '毕节地区',
            value: '毕节地区',
          },
          {
            label: '黔西南布依族苗族自治州',
            value: '黔西南布依族苗族自治州',
          },
          {
            label: '黔东南苗族侗族自治州',
            value: '黔东南苗族侗族自治州',
          },
          {
            label: '黔南布依族苗族自治州',
            value: '黔南布依族苗族自治州',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '云南',
        value: '云南',
        children: [
          {
            label: '昆明',
            value: '昆明',
          },
          {
            label: '曲靖',
            value: '曲靖',
          },
          {
            label: '玉溪',
            value: '玉溪',
          },
          {
            label: '保山',
            value: '保山',
          },
          {
            label: '昭通',
            value: '昭通',
          },
          {
            label: '丽江',
            value: '丽江',
          },
          {
            label: '普洱',
            value: '普洱',
          },
          {
            label: '临沧',
            value: '临沧',
          },
          {
            label: '德宏傣族景颇族自治州',
            value: '德宏傣族景颇族自治州',
          },
          {
            label: '怒江傈僳族自治州',
            value: '怒江傈僳族自治州',
          },
          {
            label: '迪庆藏族自治州',
            value: '迪庆藏族自治州',
          },
          {
            label: '大理白族自治州',
            value: '大理白族自治州',
          },
          {
            label: '楚雄彝族自治州',
            value: '楚雄彝族自治州',
          },
          {
            label: '红河哈尼族彝族自治州',
            value: '红河哈尼族彝族自治州',
          },
          {
            label: '文山壮族苗族自治州',
            value: '文山壮族苗族自治州',
          },
          {
            label: '西双版纳傣族自治州',
            value: '西双版纳傣族自治州',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '西藏',
        value: '西藏',
        children: [
          {
            label: '拉萨',
            value: '拉萨',
          },
          {
            label: '那曲地区',
            value: '那曲地区',
          },
          {
            label: '昌都地区',
            value: '昌都地区',
          },
          {
            label: '林芝地区',
            value: '林芝地区',
          },
          {
            label: '山南地区',
            value: '山南地区',
          },
          {
            label: '日喀则地区',
            value: '日喀则地区',
          },
          {
            label: '阿里地区',
            value: '阿里地区',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '陕西',
        value: '陕西',
        children: [
          {
            label: '西安',
            value: '西安',
          },
          {
            label: '铜川',
            value: '铜川',
          },
          {
            label: '宝鸡',
            value: '宝鸡',
          },
          {
            label: '咸阳',
            value: '咸阳',
          },
          {
            label: '渭南',
            value: '渭南',
          },
          {
            label: '延安',
            value: '延安',
          },
          {
            label: '汉中',
            value: '汉中',
          },
          {
            label: '榆林',
            value: '榆林',
          },
          {
            label: '安康',
            value: '安康',
          },
          {
            label: '商洛',
            value: '商洛',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '甘肃',
        value: '甘肃',
        children: [
          {
            label: '兰州',
            value: '兰州',
          },
          {
            label: '嘉峪关',
            value: '嘉峪关',
          },
          {
            label: '金昌',
            value: '金昌',
          },
          {
            label: '白银',
            value: '白银',
          },
          {
            label: '天水',
            value: '天水',
          },
          {
            label: '武威',
            value: '武威',
          },
          {
            label: '酒泉',
            value: '酒泉',
          },
          {
            label: '张掖',
            value: '张掖',
          },
          {
            label: '庆阳',
            value: '庆阳',
          },
          {
            label: '平凉',
            value: '平凉',
          },
          {
            label: '定西',
            value: '定西',
          },
          {
            label: '陇南',
            value: '陇南',
          },
          {
            label: '临夏回族自治州',
            value: '临夏回族自治州',
          },
          {
            label: '甘南藏族自治州',
            value: '甘南藏族自治州',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '青海',
        value: '青海',
        children: [
          {
            label: '西宁',
            value: '西宁',
          },
          {
            label: '海东地区',
            value: '海东地区',
          },
          {
            label: '海北藏族自治州',
            value: '海北藏族自治州',
          },
          {
            label: '海南藏族自治州',
            value: '海南藏族自治州',
          },
          {
            label: '黄南藏族自治州',
            value: '黄南藏族自治州',
          },
          {
            label: '果洛藏族自治州',
            value: '果洛藏族自治州',
          },
          {
            label: '玉树藏族自治州',
            value: '玉树藏族自治州',
          },
          {
            label: '海西蒙古族藏族自治州',
            value: '海西蒙古族藏族自治州',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '宁夏',
        value: '宁夏',
        children: [
          {
            label: '银川',
            value: '银川',
          },
          {
            label: '石嘴山',
            value: '石嘴山',
          },
          {
            label: '吴忠',
            value: '吴忠',
          },
          {
            label: '固原',
            value: '固原',
          },
          {
            label: '中卫',
            value: '中卫',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '新疆',
        value: '新疆',
        children: [
          {
            label: '乌鲁木齐',
            value: '乌鲁木齐',
          },
          {
            label: '克拉玛依',
            value: '克拉玛依',
          },
          {
            label: '吐鲁番地区',
            value: '吐鲁番地区',
          },
          {
            label: '哈密地区',
            value: '哈密地区',
          },
          {
            label: '和田地区',
            value: '和田地区',
          },
          {
            label: '阿克苏地区',
            value: '阿克苏地区',
          },
          {
            label: '喀什地区',
            value: '喀什地区',
          },
          {
            label: '克孜勒苏柯尔克孜自治州',
            value: '克孜勒苏柯尔克孜自治州',
          },
          {
            label: '巴音郭楞蒙古自治州',
            value: '巴音郭楞蒙古自治州',
          },
          {
            label: '昌吉回族自治州',
            value: '昌吉回族自治州',
          },
          {
            label: '博尔塔拉蒙古自治州',
            value: '博尔塔拉蒙古自治州',
          },
          {
            label: '石河子',
            value: '石河子',
          },
          {
            label: '阿拉尔',
            value: '阿拉尔',
          },
          {
            label: '图木舒克',
            value: '图木舒克',
          },
          {
            label: '五家渠',
            value: '五家渠',
          },
          {
            label: '伊犁哈萨克自治州',
            value: '伊犁哈萨克自治州',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '台湾',
        value: '台湾',
        children: [
          {
            label: '台北市',
            value: '台北市',
          },
          {
            label: '高雄市',
            value: '高雄市',
          },
          {
            label: '台北县',
            value: '台北县',
          },
          {
            label: '桃园县',
            value: '桃园县',
          },
          {
            label: '新竹县',
            value: '新竹县',
          },
          {
            label: '苗栗县',
            value: '苗栗县',
          },
          {
            label: '台中县',
            value: '台中县',
          },
          {
            label: '彰化县',
            value: '彰化县',
          },
          {
            label: '南投县',
            value: '南投县',
          },
          {
            label: '云林县',
            value: '云林县',
          },
          {
            label: '嘉义县',
            value: '嘉义县',
          },
          {
            label: '台南县',
            value: '台南县',
          },
          {
            label: '高雄县',
            value: '高雄县',
          },
          {
            label: '屏东县',
            value: '屏东县',
          },
          {
            label: '宜兰县',
            value: '宜兰县',
          },
          {
            label: '花莲县',
            value: '花莲县',
          },
          {
            label: '台东县',
            value: '台东县',
          },
          {
            label: '澎湖县',
            value: '澎湖县',
          },
          {
            label: '基隆市',
            value: '基隆市',
          },
          {
            label: '新竹市',
            value: '新竹市',
          },
          {
            label: '台中市',
            value: '台中市',
          },
          {
            label: '嘉义市',
            value: '嘉义市',
          },
          {
            label: '台南市',
            value: '台南市',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '澳门',
        value: '澳门',
        children: [
          {
            label: '花地玛堂区',
            value: '花地玛堂区',
          },
          {
            label: '圣安多尼堂区',
            value: '圣安多尼堂区',
          },
          {
            label: '大堂区',
            value: '大堂区',
          },
          {
            label: '望德堂区',
            value: '望德堂区',
          },
          {
            label: '风顺堂区',
            value: '风顺堂区',
          },
          {
            label: '嘉模堂区',
            value: '嘉模堂区',
          },
          {
            label: '圣方济各堂区',
            value: '圣方济各堂区',
          },
          {
            label: '路凼',
            value: '路凼',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
      {
        label: '香港',
        value: '香港',
        children: [
          {
            label: '中西区',
            value: '中西区',
          },
          {
            label: '湾仔区',
            value: '湾仔区',
          },
          {
            label: '东区',
            value: '东区',
          },
          {
            label: '南区',
            value: '南区',
          },
          {
            label: '深水埗区',
            value: '深水埗区',
          },
          {
            label: '油尖旺区',
            value: '油尖旺区',
          },
          {
            label: '九龙城区',
            value: '九龙城区',
          },
          {
            label: '黄大仙区',
            value: '黄大仙区',
          },
          {
            label: '观塘区',
            value: '观塘区',
          },
          {
            label: '北区',
            value: '北区',
          },
          {
            label: '大埔区',
            value: '大埔区',
          },
          {
            label: '沙田区',
            value: '沙田区',
          },
          {
            label: '西贡区',
            value: '西贡区',
          },
          {
            label: '元朗区',
            value: '元朗区',
          },
          {
            label: '屯门区',
            value: '屯门区',
          },
          {
            label: '荃湾区',
            value: '荃湾区',
          },
          {
            label: '葵青区',
            value: '葵青区',
          },
          {
            label: '离岛区',
            value: '离岛区',
          },
          {
            label: '其他',
            value: '其他',
          },
        ],
      },
    ],
  },
  // {
  //   label: '阿尔巴尼亚',
  //   value: '阿尔巴尼亚',
  // },
  // {
  //   label: '阿尔及利亚',
  //   value: '阿尔及利亚',
  // },
  // {
  //   label: '阿富汗',
  //   value: '阿富汗',
  // },
  // {
  //   label: '阿根廷',
  //   value: '阿根廷',
  // },
  // {
  //   label: '阿拉伯联合酋长国',
  //   value: '阿拉伯联合酋长国',
  // },
  // {
  //   label: '阿鲁巴',
  //   value: '阿鲁巴',
  // },
  // {
  //   label: '阿曼',
  //   value: '阿曼',
  // },
  // {
  //   label: '阿塞拜疆',
  //   value: '阿塞拜疆',
  // },
  // {
  //   label: '埃及',
  //   value: '埃及',
  // },
  // {
  //   label: '埃塞俄比亚',
  //   value: '埃塞俄比亚',
  // },
  // {
  //   label: '爱尔兰',
  //   value: '爱尔兰',
  // },
  // {
  //   label: '爱沙尼亚',
  //   value: '爱沙尼亚',
  // },
  // {
  //   label: '安道尔',
  //   value: '安道尔',
  // },
  // {
  //   label: '安哥拉',
  //   value: '安哥拉',
  // },
  // {
  //   label: '安圭拉',
  //   value: '安圭拉',
  // },
  // {
  //   label: '安提瓜和巴布达',
  //   value: '安提瓜和巴布达',
  // },
  // {
  //   label: '奥地利',
  //   value: '奥地利',
  // },
  // {
  //   label: '奥兰群岛',
  //   value: '奥兰群岛',
  // },
  // {
  //   label: '澳大利亚',
  //   value: '澳大利亚',
  // },
  // {
  //   label: '巴巴多斯',
  //   value: '巴巴多斯',
  // },
  // {
  //   label: '巴布亚新几内亚',
  //   value: '巴布亚新几内亚',
  // },
  // {
  //   label: '巴哈马',
  //   value: '巴哈马',
  // },
  // {
  //   label: '巴基斯坦',
  //   value: '巴基斯坦',
  // },
  // {
  //   label: '巴拉圭',
  //   value: '巴拉圭',
  // },
  // {
  //   label: '巴勒斯坦',
  //   value: '巴勒斯坦',
  // },
  // {
  //   label: '巴林',
  //   value: '巴林',
  // },
  // {
  //   label: '巴拿马',
  //   value: '巴拿马',
  // },
  // {
  //   label: '巴西',
  //   value: '巴西',
  // },
  // {
  //   label: '白俄罗斯',
  //   value: '白俄罗斯',
  // },
  // {
  //   label: '百慕大',
  //   value: '百慕大',
  // },
  // {
  //   label: '保加利亚',
  //   value: '保加利亚',
  // },
  // {
  //   label: '贝宁',
  //   value: '贝宁',
  // },
  // {
  //   label: '比利时',
  //   value: '比利时',
  // },
  // {
  //   label: '冰岛',
  //   value: '冰岛',
  // },
  // {
  //   label: '波多黎各',
  //   value: '波多黎各',
  // },
  // {
  //   label: '波兰',
  //   value: '波兰',
  // },
  // {
  //   label: '波斯尼亚和黑塞哥维那',
  //   value: '波斯尼亚和黑塞哥维那',
  // },
  // {
  //   label: '玻利维亚',
  //   value: '玻利维亚',
  // },
  // {
  //   label: '伯利兹',
  //   value: '伯利兹',
  // },
  // {
  //   label: '博茨瓦纳',
  //   value: '博茨瓦纳',
  // },
  // {
  //   label: '不丹',
  //   value: '不丹',
  // },
  // {
  //   label: '布基纳法索',
  //   value: '布基纳法索',
  // },
  // {
  //   label: '布隆迪',
  //   value: '布隆迪',
  // },
  // {
  //   label: '布维岛',
  //   value: '布维岛',
  // },
  // {
  //   label: '朝鲜',
  //   value: '朝鲜',
  // },
  // {
  //   label: '赤道几内亚',
  //   value: '赤道几内亚',
  // },
  // {
  //   label: '丹麦',
  //   value: '丹麦',
  // },
  // {
  //   label: '德国',
  //   value: '德国',
  // },
  // {
  //   label: '东帝汶',
  //   value: '东帝汶',
  // },
  // {
  //   label: '多哥',
  //   value: '多哥',
  // },
  // {
  //   label: '多米尼加',
  //   value: '多米尼加',
  // },
  // {
  //   label: '俄罗斯联邦',
  //   value: '俄罗斯联邦',
  // },
  // {
  //   label: '厄瓜多尔',
  //   value: '厄瓜多尔',
  // },
  // {
  //   label: '厄立特里亚',
  //   value: '厄立特里亚',
  // },
  // {
  //   label: '法国',
  //   value: '法国',
  // },
  // {
  //   label: '法国大都会',
  //   value: '法国大都会',
  // },
  // {
  //   label: '法罗群岛',
  //   value: '法罗群岛',
  // },
  // {
  //   label: '法属波利尼西亚',
  //   value: '法属波利尼西亚',
  // },
  // {
  //   label: '法属圭亚那',
  //   value: '法属圭亚那',
  // },
  // {
  //   label: '菲律宾',
  //   value: '菲律宾',
  // },
  // {
  //   label: '斐济',
  //   value: '斐济',
  // },
  // {
  //   label: '芬兰',
  //   value: '芬兰',
  // },
  // {
  //   label: '佛得角',
  //   value: '佛得角',
  // },
  // {
  //   label: '冈比亚',
  //   value: '冈比亚',
  // },
  // {
  //   label: '刚果',
  //   value: '刚果',
  // },
  // {
  //   label: '刚果（金）',
  //   value: '刚果（金）',
  // },
  // {
  //   label: '哥伦比亚',
  //   value: '哥伦比亚',
  // },
  // {
  //   label: '哥斯达黎加',
  //   value: '哥斯达黎加',
  // },
  // {
  //   label: '格林纳达',
  //   value: '格林纳达',
  // },
  // {
  //   label: '格鲁吉亚',
  //   value: '格鲁吉亚',
  // },
  // {
  //   label: '根西岛',
  //   value: '根西岛',
  // },
  // {
  //   label: '古巴',
  //   value: '古巴',
  // },
  // {
  //   label: '瓜德罗普岛',
  //   value: '瓜德罗普岛',
  // },
  // {
  //   label: '关岛',
  //   value: '关岛',
  // },
  // {
  //   label: '圭亚那',
  //   value: '圭亚那',
  // },
  // {
  //   label: '哈萨克斯坦',
  //   value: '哈萨克斯坦',
  // },
  // {
  //   label: '海地',
  //   value: '海地',
  // },
  // {
  //   label: '韩国',
  //   value: '韩国',
  // },
  // {
  //   label: '荷兰',
  //   value: '荷兰',
  // },
  // {
  //   label: '黑山',
  //   value: '黑山',
  // },
  // {
  //   label: '洪都拉斯',
  //   value: '洪都拉斯',
  // },
  // {
  //   label: '基里巴斯',
  //   value: '基里巴斯',
  // },
  // {
  //   label: '吉布提',
  //   value: '吉布提',
  // },
  // {
  //   label: '吉尔吉斯斯坦',
  //   value: '吉尔吉斯斯坦',
  // },
  // {
  //   label: '几内亚',
  //   value: '几内亚',
  // },
  // {
  //   label: '几内亚比绍',
  //   value: '几内亚比绍',
  // },
  // {
  //   label: '加拿大',
  //   value: '加拿大',
  // },
  // {
  //   label: '加纳',
  //   value: '加纳',
  // },
  // {
  //   label: '加蓬',
  //   value: '加蓬',
  // },
  // {
  //   label: '柬埔寨',
  //   value: '柬埔寨',
  // },
  // {
  //   label: '捷克',
  //   value: '捷克',
  // },
  // {
  //   label: '津巴布韦',
  //   value: '津巴布韦',
  // },
  // {
  //   label: '喀麦隆',
  //   value: '喀麦隆',
  // },
  // {
  //   label: '卡塔尔',
  //   value: '卡塔尔',
  // },
  // {
  //   label: '科科斯（基林）群岛',
  //   value: '科科斯（基林）群岛',
  // },
  // {
  //   label: '科摩罗',
  //   value: '科摩罗',
  // },
  // {
  //   label: '科特迪瓦',
  //   value: '科特迪瓦',
  // },
  // {
  //   label: '科威特',
  //   value: '科威特',
  // },
  // {
  //   label: '克罗地亚',
  //   value: '克罗地亚',
  // },
  // {
  //   label: '肯尼亚',
  //   value: '肯尼亚',
  // },
  // {
  //   label: '库克群岛',
  //   value: '库克群岛',
  // },
  // {
  //   label: '拉脱维亚',
  //   value: '拉脱维亚',
  // },
  // {
  //   label: '莱索托',
  //   value: '莱索托',
  // },
  // {
  //   label: '老挝',
  //   value: '老挝',
  // },
  // {
  //   label: '黎巴嫩',
  //   value: '黎巴嫩',
  // },
  // {
  //   label: '立陶宛',
  //   value: '立陶宛',
  // },
  // {
  //   label: '利比里亚',
  //   value: '利比里亚',
  // },
  // {
  //   label: '利比亚',
  //   value: '利比亚',
  // },
  // {
  //   label: '列支敦士登',
  //   value: '列支敦士登',
  // },
  // {
  //   label: '留尼汪岛',
  //   value: '留尼汪岛',
  // },
  // {
  //   label: '卢森堡',
  //   value: '卢森堡',
  // },
  // {
  //   label: '卢旺达',
  //   value: '卢旺达',
  // },
  // {
  //   label: '罗马尼亚',
  //   value: '罗马尼亚',
  // },
  // {
  //   label: '马达加斯加',
  //   value: '马达加斯加',
  // },
  // {
  //   label: '马恩岛',
  //   value: '马恩岛',
  // },
  // {
  //   label: '马尔代夫',
  //   value: '马尔代夫',
  // },
  // {
  //   label: '马耳他',
  //   value: '马耳他',
  // },
  // {
  //   label: '马拉维',
  //   value: '马拉维',
  // },
  // {
  //   label: '马来西亚',
  //   value: '马来西亚',
  // },
  // {
  //   label: '马里',
  //   value: '马里',
  // },
  // {
  //   label: '马其顿',
  //   value: '马其顿',
  // },
  // {
  //   label: '马绍尔群岛',
  //   value: '马绍尔群岛',
  // },
  // {
  //   label: '马提尼克岛',
  //   value: '马提尼克岛',
  // },
  // {
  //   label: '马约特',
  //   value: '马约特',
  // },
  // {
  //   label: '毛里求斯',
  //   value: '毛里求斯',
  // },
  // {
  //   label: '毛里塔尼亚',
  //   value: '毛里塔尼亚',
  // },
  // {
  //   label: '美国',
  //   value: '美国',
  // },
  // {
  //   label: '美属萨摩亚',
  //   value: '美属萨摩亚',
  // },
  // {
  //   label: '蒙古',
  //   value: '蒙古',
  // },
  // {
  //   label: '蒙特塞拉特',
  //   value: '蒙特塞拉特',
  // },
  // {
  //   label: '孟加拉',
  //   value: '孟加拉',
  // },
  // {
  //   label: '秘鲁',
  //   value: '秘鲁',
  // },
  // {
  //   label: '密克罗尼西亚',
  //   value: '密克罗尼西亚',
  // },
  // {
  //   label: '缅甸',
  //   value: '缅甸',
  // },
  // {
  //   label: '摩尔多瓦',
  //   value: '摩尔多瓦',
  // },
  // {
  //   label: '摩洛哥',
  //   value: '摩洛哥',
  // },
  // {
  //   label: '摩纳哥',
  //   value: '摩纳哥',
  // },
  // {
  //   label: '莫桑比克',
  //   value: '莫桑比克',
  // },
  // {
  //   label: '墨西哥',
  //   value: '墨西哥',
  // },
  // {
  //   label: '纳米比亚',
  //   value: '纳米比亚',
  // },
  // {
  //   label: '南非',
  //   value: '南非',
  // },
  // {
  //   label: '瑙鲁',
  //   value: '瑙鲁',
  // },
  // {
  //   label: '尼泊尔',
  //   value: '尼泊尔',
  // },
  // {
  //   label: '尼加拉瓜',
  //   value: '尼加拉瓜',
  // },
  // {
  //   label: '尼日尔',
  //   value: '尼日尔',
  // },
  // {
  //   label: '尼日利亚',
  //   value: '尼日利亚',
  // },
  // {
  //   label: '纽埃',
  //   value: '纽埃',
  // },
  // {
  //   label: '挪威',
  //   value: '挪威',
  // },
  // {
  //   label: '诺福克岛',
  //   value: '诺福克岛',
  // },
  // {
  //   label: '帕劳',
  //   value: '帕劳',
  // },
  // {
  //   label: '皮特凯恩群岛',
  //   value: '皮特凯恩群岛',
  // },
  // {
  //   label: '葡萄牙',
  //   value: '葡萄牙',
  // },
  // {
  //   label: '日本',
  //   value: '日本',
  // },
  // {
  //   label: '瑞典',
  //   value: '瑞典',
  // },
  // {
  //   label: '瑞士',
  //   value: '瑞士',
  // },
  // {
  //   label: '萨尔瓦多',
  //   value: '萨尔瓦多',
  // },
  // {
  //   label: '萨摩亚',
  //   value: '萨摩亚',
  // },
  // {
  //   label: '塞尔维亚',
  //   value: '塞尔维亚',
  // },
  // {
  //   label: '塞拉利昂',
  //   value: '塞拉利昂',
  // },
  // {
  //   label: '塞内加尔',
  //   value: '塞内加尔',
  // },
  // {
  //   label: '塞浦路斯',
  //   value: '塞浦路斯',
  // },
  // {
  //   label: '塞舌尔',
  //   value: '塞舌尔',
  // },
  // {
  //   label: '沙特阿拉伯',
  //   value: '沙特阿拉伯',
  // },
  // {
  //   label: '圣诞岛',
  //   value: '圣诞岛',
  // },
  // {
  //   label: '圣多美和普林西比',
  //   value: '圣多美和普林西比',
  // },
  // {
  //   label: '圣赫勒拿',
  //   value: '圣赫勒拿',
  // },
  // {
  //   label: '圣基茨和尼维斯',
  //   value: '圣基茨和尼维斯',
  // },
  // {
  //   label: '圣卢西亚',
  //   value: '圣卢西亚',
  // },
  // {
  //   label: '圣马力诺',
  //   value: '圣马力诺',
  // },
  // {
  //   label: '圣文森特和格林纳丁斯',
  //   value: '圣文森特和格林纳丁斯',
  // },
  // {
  //   label: '斯里兰卡',
  //   value: '斯里兰卡',
  // },
  // {
  //   label: '斯洛伐克',
  //   value: '斯洛伐克',
  // },
  // {
  //   label: '斯洛文尼亚',
  //   value: '斯洛文尼亚',
  // },
  // {
  //   label: '斯威士兰',
  //   value: '斯威士兰',
  // },
  // {
  //   label: '苏丹',
  //   value: '苏丹',
  // },
  // {
  //   label: '苏里南',
  //   value: '苏里南',
  // },
  // {
  //   label: '所罗门群岛',
  //   value: '所罗门群岛',
  // },
  // {
  //   label: '索马里',
  //   value: '索马里',
  // },
  // {
  //   label: '塔吉克斯坦',
  //   value: '塔吉克斯坦',
  // },
  // {
  //   label: '泰国',
  //   value: '泰国',
  // },
  // {
  //   label: '汤加',
  //   value: '汤加',
  // },
  // {
  //   label: '特立尼达和多巴哥',
  //   value: '特立尼达和多巴哥',
  // },
  // {
  //   label: '突尼斯',
  //   value: '突尼斯',
  // },
  // {
  //   label: '图瓦卢',
  //   value: '图瓦卢',
  // },
  // {
  //   label: '土耳其',
  //   value: '土耳其',
  // },
  // {
  //   label: '土库曼斯坦',
  //   value: '土库曼斯坦',
  // },
  // {
  //   label: '托克劳',
  //   value: '托克劳',
  // },
  // {
  //   label: '瓦利斯群岛和富图纳群岛',
  //   value: '瓦利斯群岛和富图纳群岛',
  // },
  // {
  //   label: '瓦努阿图',
  //   value: '瓦努阿图',
  // },
  // {
  //   label: '危地马拉',
  //   value: '危地马拉',
  // },
  // {
  //   label: '委内瑞拉',
  //   value: '委内瑞拉',
  // },
  // {
  //   label: '文莱',
  //   value: '文莱',
  // },
  // {
  //   label: '乌干达',
  //   value: '乌干达',
  // },
  // {
  //   label: '乌克兰',
  //   value: '乌克兰',
  // },
  // {
  //   label: '乌拉圭',
  //   value: '乌拉圭',
  // },
  // {
  //   label: '乌兹别克斯坦',
  //   value: '乌兹别克斯坦',
  // },
  // {
  //   label: '西班牙',
  //   value: '西班牙',
  // },
  // {
  //   label: '西撒哈拉',
  //   value: '西撒哈拉',
  // },
  // {
  //   label: '希腊',
  //   value: '希腊',
  // },
  // {
  //   label: '新加坡',
  //   value: '新加坡',
  // },
  // {
  //   label: '新喀里多尼亚',
  //   value: '新喀里多尼亚',
  // },
  // {
  //   label: '新西兰',
  //   value: '新西兰',
  // },
  // {
  //   label: '匈牙利',
  //   value: '匈牙利',
  // },
  // {
  //   label: '叙利亚',
  //   value: '叙利亚',
  // },
  // {
  //   label: '牙买加',
  //   value: '牙买加',
  // },
  // {
  //   label: '亚美尼亚',
  //   value: '亚美尼亚',
  // },
  // {
  //   label: '也门',
  //   value: '也门',
  // },
  // {
  //   label: '伊拉克',
  //   value: '伊拉克',
  // },
  // {
  //   label: '伊朗',
  //   value: '伊朗',
  // },
  // {
  //   label: '以色列',
  //   value: '以色列',
  // },
  // {
  //   label: '意大利',
  //   value: '意大利',
  // },
  // {
  //   label: '印度',
  //   value: '印度',
  // },
  // {
  //   label: '印度尼西亚',
  //   value: '印度尼西亚',
  // },
  // {
  //   label: '英国',
  //   value: '英国',
  // },
  // {
  //   label: '约旦',
  //   value: '约旦',
  // },
  // {
  //   label: '越南',
  //   value: '越南',
  // },
  // {
  //   label: '赞比亚',
  //   value: '赞比亚',
  // },
  // {
  //   label: '乍得',
  //   value: '乍得',
  // },
  // {
  //   label: '直布罗陀',
  //   value: '直布罗陀',
  // },
  // {
  //   label: '智利',
  //   value: '智利',
  // },
  // {
  //   label: '中非',
  //   value: '中非',
  // },
]
